"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WITHDRAW_CONSENT_REQUEST_EXAMPLE = exports.GRANT_CONSENT_REQUEST_EXAMPLE = exports.withdrawConsentRequestSchema = exports.grantConsentRequestSchema = void 0;
const zod_1 = require("zod");
const signatureSchema = zod_1.z.object({
    signedByPatientId: zod_1.z.string().uuid().optional(),
    signedByGuardianId: zod_1.z.string().uuid().optional(),
    witnessUserId: zod_1.z.string().uuid().optional(),
    documentHash: zod_1.z.string().min(1),
    method: zod_1.z.enum(['DRAWN', 'TYPED', 'BIOMETRIC', 'OTP_CONFIRMED']),
    signatureStorageKey: zod_1.z.string().optional(),
});
exports.grantConsentRequestSchema = zod_1.z.object({
    patientId: zod_1.z.string().uuid(),
    consentType: zod_1.z.enum([
        'GENERAL',
        'TREATMENT',
        'PROCEDURE_SPECIFIC',
        'BLOOD_TRANSFUSION',
        'INSURANCE_DATA_SHARING',
        'RESEARCH',
        'PRIVACY_POLICY',
        'TELEMEDICINE',
    ]),
    scopeDescription: zod_1.z.string().min(1),
    grantedByGuardianId: zod_1.z.string().uuid().optional(),
    validTo: zod_1.z.coerce.date().optional(),
    signature: signatureSchema.optional(),
});
exports.withdrawConsentRequestSchema = zod_1.z.object({
    consentId: zod_1.z.string().uuid(),
    revokedReason: zod_1.z.string().min(1),
});
exports.GRANT_CONSENT_REQUEST_EXAMPLE = {
    patientId: '22222222-2222-2222-2222-222222222222',
    consentType: 'TREATMENT',
    scopeDescription: 'General consent for OPD consultation and diagnostic tests',
};
exports.WITHDRAW_CONSENT_REQUEST_EXAMPLE = {
    consentId: '55555555-5555-5555-5555-555555555555',
    revokedReason: 'Patient formally withdrew consent at front desk',
};
//# sourceMappingURL=consent.request.js.map